// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-2Rkzj";
var _4 = "wrapper-2t1Z3";
var _5 = "ticket-1fJ7r";
var _6 = "messages-1E5y7";
var _7 = "services-1LRlI";
var _8 = "receipt-2F_xX";
var _9 = "form-1Rthh";
var _a = "breadcrumb-3-ijv";
var _b = "footer-3LcGV";
var _c = "scrollBody-1w29J";
var _d = "paper-3MQcE";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "wrapper", _5 as "ticket", _6 as "messages", _7 as "services", _8 as "receipt", _9 as "form", _a as "breadcrumb", _b as "footer", _c as "scrollBody", _d as "paper" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "wrapper": _4, "ticket": _5, "messages": _6, "services": _7, "receipt": _8, "form": _9, "breadcrumb": _a, "footer": _b, "scrollBody": _c, "paper": _d }
